<template>
    <div>
    <Nav/>
    <div>
      <div>
      <div class="flex flex-wrap gap-2 pl-3 pr-3 mt-2 border-b-2 pb-3">
          
          <div class="border-2 rounded-md px-2 py-1">
              Teether
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Montessori
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Baby Rattle
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              Wooden
          </div>
          <div class="border-2 rounded-md px-2 py-1">
              OUtdoor
          </div>
      </div>
      <div class="mt-2">
          <p class="text-xs pl-3 font-bold text-gray-400">Price and other details may vary based on the product size and color</p>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
            
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="flex flex-col sm:flex-row ml-4 mr-4 mt-6 gap-4 border-b pb-4">
          <div>
              <a href="">
  
                  <img src="/bottomcard36.jpg" alt="" class="w-full sm:w-48 md:w-56 lg:w-64 object-cover rounded-md flex-shrink-0">
              </a>
          </div>
          <a href="">
          <div class="ml-5">
             
              <div class="text-sm font-semibold">                
                 
                  LANEIGE Lip Sleeping MAsk Stocking Stuffer:Nourish,Hydrate,Vitamin C,Murumuru & Shea..
              </div>
              <div class="text-sm mt-1 font-semibold">
                  Options: <span class="text-blue-300">10 styles</span>
              </div>
              <div class="mt-1 text-sm font-semibold">
                  #1 Top Rated <br>
                  <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
              </div>
              <div class="mt-1 font-semibold text-sm text-gray-400">
                  No featured offers available <span class="text-black">$24.00 </span> (10 new offers)
              </div>
              <div class="text-sm mt-2 w-60 px-2 -ml-2 ">
                  <button class="border-2 px-16 rounded-3xl py-2 bg-yellow-300">Add to Cart</button>
              </div>
          </div>
      </a>
      </div>
      <div class="mt-5">
        <div class="bg-gray-600 text-white text-center py-2">
  <div><i class="fa-solid fa-caret-up"></i></div>
  <div class="text-sm">TOP OF PAGE</div>
        </div>
        <div class="bg-gray-800 grid grid-cols-2 sm:grid-cols-3 gap-6 pt-4 text-white px-5 pb-6 max-w-screen-xl mx-auto">
  <div>
    <div><a href="">Amazon.com</a></div>
    <div class="mt-5"><a href="">Your Lists</a></div>
    <div class="mt-5"><a href="">Registory & Gift List</a></div>
    <div class="mt-5"><a href="">Your Account</a></div>
    <div class="mt-5"><a href="">Sell Products on Amazon</a></div>
    <div class="mt-5"><a href="">Recalls and Product Safety <br> Alerts</a></div>
    <div class="mt-5"><a href="">Customer Service</a></div>
  
  </div>
  <div class="ml-5">
    <div><a href="">Your Orders</a></div>
    <div class="mt-5"><a href="">Gift Cards</a></div>
    <div class="mt-5"><a href="">Find a Gift</a></div>
    <div class="mt-5"><a href="">Browsing History</a></div>
    <div class="mt-5"><a href="">Your Returns</a></div>
  </div>
        </div>
        <div class="bg-gray-900 text-white pt-10 pb-10">
  <div class="flex flex-wrap gap-4 px-4 justify-center">
  <div class="text-sm"><i class="fa-solid fa-globe"></i> English</div>
  <div class="text-sm ml-7">$ USD - US. Dollar</div>
  <div class="text-sm ml-7"><img src="/united.jpg" alt="" class="w-6 h-4 inline-block"> United States</div>
  </div>
  <div class="mt-10">
  <div class="text-center">
    Already a customer? <a href="">Sign in</a>
  </div>
  <div class="mt-5 flex text-xs ml-1 mr-1">
  <div><a href="" class="w-80">Conditions of Use</a></div>
  <div><a href="" class="ml-3">Privacy Notice</a></div>
  <div><a href="" class="ml-3">Consumer Health Data Privacy Disclosure</a></div>
  </div>
  <div class="text-center text-xs">Your Ads Privacy Choices <input type="checkbox" class="mt-2 ml-2"></div>
  <div class="text-center text-xs mt-3">&copy;1996-2024, Amazon.com, Inc. or its affiliates</div>
  </div>
        </div>
       </div>
    </div>
  </div>
  
    </div>
  </template>
  
  <script>
  import Nav from '@/components/Nav.vue'
  export default {
  components:{
      Nav
  }
  }
  </script>
  
  <style>
  
  </style>
